import React, { useState } from "react";
import { Card, DataTable, hasActiveFilters, useFilterSortPagination, } from "@sscs/ui";
import { getPageItems, getQueryStatus, sortItems } from "@sscs/utils";
import { useGetComponentActionsQuery } from "../../services/fileBrowser.api";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import EventRow from "./event/EventRow";
import Filter from "./filter/Filter";
import { filterActions, initFilter, initSort } from "./utils";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "on_event",
        label: "On event",
        sortProperty: "on_event",
        sortId: "on-event-sort",
        width: "300px",
    },
    {
        id: "event_name",
        label: "Event name",
        sortProperty: "event_name",
        sortId: "event-name-sort",
        width: "40%",
    },
    {
        id: "do_action",
        label: "Do action",
        sortProperty: "do_action",
        sortId: "do-action-sort",
        width: "60%",
    },
];
const Events = () => {
    const { fileId, reportId } = useGetFileAndReportId();
    const { data = { actions: [], action_mappings: {} }, isLoading, isFetching, isError, error, } = useGetComponentActionsQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const { filter, sort, pagination, handleFilterChange, handleSortChange, handlePaginationChange, } = useFilterSortPagination(initFilter, initSort);
    const [focusedRow, setFocusedRow] = useState(null);
    const filteredData = filterActions(data.actions, filter);
    const sortedData = sortItems(filteredData, {
        property: sort.property,
        reverse: sort.reverse,
    });
    const paginatedData = getPageItems(sortedData, pagination.currentPage, pagination.itemsPerPage);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card.Filters, { found: {
                id: "events-clear-all-filters",
                count: sortedData.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => handleFilterChange(initFilter),
            } },
            React.createElement(Filter, { filter: filter, actionTypes: Array.from(data.actions.reduce((actionSet, event) => {
                    actionSet.add(event.do_action);
                    return actionSet;
                }, new Set())), eventTypes: Array.from(data.actions.reduce((actionSet, event) => {
                    actionSet.add(event.on_event);
                    return actionSet;
                }, new Set())), onChange: (filter) => handleFilterChange(filter) })),
        React.createElement(DataTable, { chrome: "plain", columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                subject: "events",
                filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => handleFilterChange(initFilter),
                },
            }, status: getQueryStatus({
                data,
                isLoading,
                isFetching,
                isError,
                error,
            }), pagination: {
                id: "events-pagination",
                itemCount: sortedData.length,
                pagination,
                onChange: handlePaginationChange,
            } }, paginatedData.map((event, index) => (React.createElement(EventRow, { key: event.id, event: event, actionMappings: data.action_mappings, eventNameFilter: filter.eventName, rowIndex: index, onClick: () => setFocusedRow(event.id), focused: focusedRow === event.id }))))));
};
export default Events;
//# sourceMappingURL=Events.js.map